export default __webpack_public_path__ + "static/media/alk_mini_logo.581c1def.jpg";